<template>
    <app-page-content>
        <div class="d-print-none">
            <app-title text="Página de Administración para Clientes" />
        </div>
        <router-view></router-view>
    </app-page-content>
</template>
<script>
    export default {
        
    }
</script>